/* Minimalerei PDP-Module: Rückseite (Auto-Drehung), Weihnachtsfrist (Platzierung), feste Kaufleiste,
   Anlässe mit Kundenstimme, Maße & Pflege zusammenlegen */
(function(){
  if (window.__mpxInit) return; window.__mpxInit = true;
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initFlips(){
    document.querySelectorAll('[data-mpx-flip]').forEach(function(el){
      if (el.__mpx) return; el.__mpx = true;
      var hint = el.parentElement.querySelector('[data-mpx-flip-hint]');
      var every = parseFloat(el.getAttribute('data-mpx-every') || '3.2') * 1000;
      var last = 0, vis = false;
      function label(){ if(!hint) return; hint.innerHTML = el.classList.contains('is-back') ? hint.getAttribute('data-back') : hint.getAttribute('data-front'); }
      el.addEventListener('click', function(){ last = Date.now(); el.classList.toggle('is-back'); label(); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function(es){ es.forEach(function(e){ vis = e.isIntersecting; }); }, {threshold:.4}).observe(el);
      if (!RM && every > 0) setInterval(function(){ if (!vis || Date.now() - last < 8000) return; el.classList.toggle('is-back'); label(); }, every);
    });
  }

  function initDeadlines(){
    document.querySelectorAll('[data-mpx-deadline]').forEach(function(el){
      if (el.__mpx) return; el.__mpx = true;
      var until = el.getAttribute('data-until');
      if (until && new Date() > new Date(until + 'T23:59:59')) { el.remove(); return; }
      var target = document.querySelector(el.getAttribute('data-after') || '.buy-box__delivery');
      if (target) target.insertAdjacentElement('afterend', el);
      el.hidden = false;
    });
  }

  function priceText(){
    var p = document.querySelector('.buy-box__price');
    if (!p) return '';
    var m = p.innerText.replace(/\s+/g,' ').match(/\d{1,3}(?:\.\d{3})*,\d{2}\s?€/);
    return m ? m[0].replace(/\s/g,' ') : '';
  }

  function initSticky(){
    var bar = document.querySelector('[data-mpx-sticky]');
    if (!bar || bar.__mpx) return; bar.__mpx = true;
    document.body.appendChild(bar);
    var btn = bar.querySelector('.mpx-sticky__btn');
    var lbl = bar.querySelector('[data-mpx-label]');
    var base = lbl.getAttribute('data-text');
    var showPrice = bar.getAttribute('data-price') === 'true';
    var startSel = bar.getAttribute('data-start') || '.ge-start-knopf';
    var watchSel = bar.getAttribute('data-watch') || '.ge-karte';
    function setLabel(){ var pr = showPrice ? priceText() : ''; lbl.textContent = pr ? base + ' · ' + pr : base; }
    setLabel();
    document.addEventListener('change', function(){ setTimeout(setLabel, 60); });
    var hideWidgets = bar.getAttribute('data-hide-widgets') !== 'false';
    if (!hideWidgets && document.querySelector('#ShopifyChat, shopify-chat, [id^="shopify-chat"], .shopify-chat')) bar.classList.add('has-chat');
    /* Chat-Launcher und Cookie-Symbol ausblenden, solange die Leiste sichtbar ist.
       Nie das Cookie-Banner selbst und nie einen geöffneten Chat. */
    function widgetEls(){
      var els = [];
      var chat = document.querySelector('shopify-chat');
      var rt = chat && chat.shadowRoot && chat.shadowRoot.querySelector('shopify-agent-runtime');
      var act = rt && rt.shadowRoot && rt.shadowRoot.querySelector('button.activator');
      if (act && act.getAttribute('aria-expanded') !== 'true') els.push(act);
      var cmp = document.querySelector('pandectes-cmp');
      var btn = cmp && cmp.shadowRoot && cmp.shadowRoot.querySelector('button.widget');
      if (btn) els.push(btn);
      return els;
    }
    var hidden = [];
    function setWidgets(on){
      if (!hideWidgets) return;
      if (on) {
        hidden = widgetEls();
        hidden.forEach(function(el){ el.style.transition = 'opacity .25s'; el.style.opacity = '0'; el.style.pointerEvents = 'none'; });
      } else {
        hidden.forEach(function(el){ el.style.opacity = ''; el.style.pointerEvents = ''; });
        hidden = [];
      }
    }
    btn.addEventListener('click', function(){
      var start = document.querySelector(startSel);
      var card = document.querySelector(watchSel) || start;
      if (card) card.scrollIntoView({behavior: RM ? 'auto' : 'smooth', block:'center'});
      if (start) setTimeout(function(){ start.click(); }, RM ? 0 : 450);
    });
    var ticking = false;
    function check(){
      ticking = false;
      var target = document.querySelector(watchSel) || document.querySelector(startSel);
      if (!target) { if (bar.classList.contains('is-on')) setWidgets(false); bar.classList.remove('is-on'); return; }
      var r = target.getBoundingClientRect();
      var on = r.bottom < 0;
      if (on !== bar.classList.contains('is-on')) setWidgets(on);
      bar.classList.toggle('is-on', on);
    }
    function onScroll(){ if (!ticking) { ticking = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll);
    check();
  }


  /* Anlässe: Tipp zeigt Text und Kundenstimme, wechselt sonst von selbst */
  function initOcc(){
    document.querySelectorAll('[data-mpx-occ]').forEach(function(el){
      if (el.__mpx) return; el.__mpx = true;
      var pills = Array.prototype.slice.call(el.querySelectorAll('[data-occ]'));
      if (!pills.length) return;
      var every = parseFloat(el.getAttribute('data-every') || '0') * 1000;
      var cur = 0, timer = null, vis = false, hover = false, pausedUntil = 0;
      el.style.setProperty('--occ-dur', (every / 1000) + 's');
      function show(i){
        cur = i; var b = pills[i], id = b.getAttribute('data-occ');
        pills.forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        el.querySelectorAll('[data-occ-panel]').forEach(function(p){
          var on = p.getAttribute('data-occ-panel') === id;
          p.hidden = !on;
          if (on && p.classList.contains('mpx-occ__card') && !RM){ p.classList.remove('is-in'); void p.offsetWidth; p.classList.add('is-in'); }
        });
      }
      function running(){ return every > 0 && !RM && vis && !hover && Date.now() >= pausedUntil; }
      function schedule(){
        clearTimeout(timer);
        var on = running();
        el.classList.toggle('is-auto', on);
        if (on) {
          var b = pills[cur]; b.classList.remove('is-tick'); void b.offsetWidth; b.classList.add('is-tick');
          timer = setTimeout(function(){ show((cur + 1) % pills.length); schedule(); }, every);
        } else if (every > 0 && Date.now() < pausedUntil) {
          timer = setTimeout(schedule, pausedUntil - Date.now() + 50);
        }
      }
      pills.forEach(function(b, i){
        b.addEventListener('click', function(){ show(i); pausedUntil = Date.now() + 12000; schedule(); });
      });
      el.addEventListener('mouseenter', function(){ hover = true; schedule(); });
      el.addEventListener('mouseleave', function(){ hover = false; schedule(); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function(es){ es.forEach(function(e){ vis = e.isIntersecting; }); schedule(); }, {threshold:.35}).observe(el);
      else { vis = true; schedule(); }
    });
  }

  /* Bewertungen: lange Texte einklappen, weitere Bewertungen zeigen */
  function initReviews(){
    document.querySelectorAll('[data-mpx-rev]').forEach(function(el){
      if (el.__mpx) return; el.__mpx = true;
      el.querySelectorAll('.mpx-rev__text').forEach(function(t){
        if (t.scrollHeight - t.clientHeight < 4) return;
        var b = document.createElement('button'); b.type = 'button'; b.className = 'mpx-rev__readmore'; b.textContent = 'Weiterlesen';
        b.addEventListener('click', function(){ var open = t.classList.toggle('is-open'); b.textContent = open ? 'Weniger' : 'Weiterlesen'; });
        t.insertAdjacentElement('afterend', b);
      });
      var more = el.querySelector('[data-mpx-rev-more]');
      if (more) more.addEventListener('click', function(){
        var all = el.classList.toggle('is-all');
        more.setAttribute('aria-expanded', all ? 'true' : 'false');
        more.textContent = all ? more.getAttribute('data-less') : more.getAttribute('data-more');
        if (all) el.querySelectorAll('.mpx-rev__card.is-extra .mpx-rev__text').forEach(function(t){
          if (t.nextElementSibling && t.nextElementSibling.classList.contains('mpx-rev__readmore')) return;
          if (t.scrollHeight - t.clientHeight < 4) return;
          var b = document.createElement('button'); b.type = 'button'; b.className = 'mpx-rev__readmore'; b.textContent = 'Weiterlesen';
          b.addEventListener('click', function(){ var open = t.classList.toggle('is-open'); b.textContent = open ? 'Weniger' : 'Weiterlesen'; });
          t.insertAdjacentElement('afterend', b);
        });
      });
    });
  }

  /* Maße & Details + Pflegehinweise zu einem Aufklapper zusammenlegen */
  function initMergeCare(){
    var flag = document.querySelector('[data-mpx-merge-care]');
    if (!flag || flag.__mpx) return; flag.__mpx = true;
    var items = Array.prototype.slice.call(document.querySelectorAll('.mp-description__item'));
    function find(word){ return items.filter(function(d){ var t = d.querySelector('.mp-description__text'); return t && t.textContent.toLowerCase().indexOf(word) > -1; })[0]; }
    var details = find('maße'), care = find('pflege');
    if (!details || !care) return;
    var dc = details.querySelector('.mp-description__content'), cc = care.querySelector('.mp-description__content');
    if (!dc || !cc) return;
    var h = document.createElement('p'); h.className = 'mpx-merge-h'; h.innerHTML = '<strong></strong>';
    h.firstChild.textContent = flag.getAttribute('data-care-title') || 'Pflege';
    dc.appendChild(h);
    while (cc.firstChild) dc.appendChild(cc.firstChild);
    var lbl = details.querySelector('.mp-description__text');
    if (lbl && flag.getAttribute('data-label')) lbl.textContent = flag.getAttribute('data-label');
    care.remove();
  }

  function init(){ initFlips(); initDeadlines(); initSticky(); initOcc(); initMergeCare(); initReviews(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
